import { Metamodel } from '../base/model';
import { IModel, IAttribute, IViolation, IValidationContext } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { SqlServerLinkedService } from './sql-server.linkedservice';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { GlobalVariables } from '../../constants/globals';
import {validateLinkedServiceProperties} from '../../shared/utils/linkedservice-validation-util';
import { SqlVersionType } from '../../constants/sql-constants';

@Metamodel.model({
    name: ModelConstants.fabricSqlLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SqlDatabase_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.SqlDatabase_DisplayText)
    ],
    validator: FabricSqlLinkedService.validateFabricSqlLinkedService
})
export class FabricSqlLinkedService extends SqlServerLinkedService {
    public static readonly MODEL: IModel;
    public static readonly WORKSPACE_ID: IAttribute;
    public static readonly ARTIFACT_ID: IAttribute;
    public static readonly ENDPOINT: IAttribute;
    public static readonly DATABASE: IAttribute;

    public static async validateFabricSqlLinkedService(
        linkedService: FabricSqlLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        if (GlobalVariables.isTrident) {
            return validateLinkedServiceProperties(linkedService, [
                FabricSqlLinkedService.ARTIFACT_ID,
                FabricSqlLinkedService.WORKSPACE_ID
            ]);
        }
        return undefined;
    }

    public override readonly tridentArtifactType: 'SQLDbNative' = GlobalVariables.isTrident ? ModelConstants.fabricSqlArtifactType : undefined;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        accepts: ['String'],
        templatable: true
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        display: format(shellStringResources.ObjectIdLabel, shellStringResources.SqlDatabase_DisplayText),
        association: 'ARTIFACT_ID',
        accepts: ['String'],
        templatable: true
    })
    public artifactId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        accepts: ['String'],
        templatable: true
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.Database,
        association: 'DATABASE',
        accepts: ['String'],
        templatable: true
    })
    public database?: string;

    public sqlVersion: SqlVersionType = 'v2'; 
    public sqlAnalyticsEndpoint: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
